import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import { CircularProgress, DialogContent, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import cloudStore from "../../store/CloudStore";
import { useDialog } from "../Dialogs/DialogProvider";
import { updateQrCodes } from "../WebcodeSetting/WebcodeApi";

function SelectSalesAreaMerchant(props) {
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [, closeDialog] = useDialog();
  let loading = open && options.length === 0;

  const search = (searchValue) => {
    return cloudStore.merchants.reduce((salesareaMerchants, merchant) => {
      if (salesareaMerchants.length > 9) {
        return salesareaMerchants;
      }
      if (merchant.name == null || merchant.merchant_id == null) {
        return salesareaMerchants;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            merchant.name.toLowerCase().includes(value.toLowerCase()) ||
            merchant.merchant_id.toString().toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        merchant.sp_merchants.forEach((spMerchant) => {
          spMerchant.inhouse = true;
          spMerchant.name = "Inhouse " + merchant.name;
        });
        merchant.ta_merchants.forEach((taMerchant) => {
          taMerchant.takeaway = true;
          taMerchant.name = "Takeaway " + merchant.name;
        });
        salesareaMerchants = salesareaMerchants.concat(merchant.sp_merchants);
        salesareaMerchants = salesareaMerchants.concat(merchant.ta_merchants);
      }

      return salesareaMerchants;
    }, []);
  };

  useEffect(() => {
    if (selectedOption) {
      const qrCodes = Object.keys(props.selectedSpQrCodes)
        .filter((identifier) => props.selectedSpQrCodes[identifier])
        .map((identifier) => ({
          identifier: identifier,
        }));
      const newValues = Object.keys(props.selectedSpQrCodes)
        .filter((identifier) => props.selectedSpQrCodes[identifier])
        .map((identifier) => {
          if (selectedOption.inhouse) {
            return { sp_merchant_id: selectedOption.id };
          } else {
            return { ta_merchant_id: selectedOption.id };
          }
        });

      updateQrCodes(props.merchantId, qrCodes, newValues).then(() => {
        props.onUpdated();
        closeDialog();
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const spMerchants = await search(searchValue);
      if (active) {
        setOptions(spMerchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <>
      <DialogContent>
        <Typography variant={"h6"}>Select Takeaway/Inhouse merchant</Typography>
        <Autocomplete
          style={{ width: 300 }}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
            setSearchValue("");
          }}
          filterOptions={(x) => x}
          onChange={(e, value) => {
            if (value) {
              setSelectedOption(value);
            }
          }}
          onInputChange={(event, value) => {
            setSearchValue(value);
          }}
          getOptionLabel={(option) => option.name + " - " + option.id}
          options={options}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label={props.intl.formatMessage({ id: "Search" })}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </DialogContent>
    </>
  );
}

export default withIntl(SelectSalesAreaMerchant);
